import { parseName } from "humanparser";
import submitHubspotForm from "../../../shared/utils/submitHubspotForm";

interface SignUpData {
  name: string;
  organization?: string;
  email: string;
}

export default function hubspotSignUp(signUpData: SignUpData, formId: string): Promise<void> {
  const name = parseName(signUpData.name);
  return submitHubspotForm(formId, [
    { name: "firstname", value: name.firstName },
    { name: "lastname", value: name.lastName },
    { name: "company", value: signUpData.organization },
    { name: "email", value: signUpData.email },
  ]);
}
